module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-769-min.b86006ea.jpg";